import * as React from "react";
import {
  Container,
  Grid,
  Input, Typography
} from "@mui/material";
import {useState} from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import {findSubject} from "../participant";
import {waitInputComplete} from "../../../fn";
import {FormSelectCtrl} from "../../../domains/common/components/FormSelect";
import {stateManager} from "../../../stateManager";

/**
 * @typedef RealtyValue
 * @type {Object}
 * @property {string} type
 * @property {string} cadNum
 * @property {string} realtyFiasCode
 * @property {string} regionCode
 */

/**
 *
 * @constructor
 */
export default function SearchSubject({onSelect}) {
  const [state, setState] = useState([])

  const searchSubject = async (event) => {
    if (event?.target?.value?.length >= 2) {
      const result = await findSubject(event.target.value);
      setState(result);
    } else {
      setState([]);
    }
  }

  const onClick = (subject) => {
    onSelect(subject);
  }

  const waitChangeForm = waitInputComplete(searchSubject, 500);

  return (
      <Container>
        <Grid container xs={12} width={500}>
          <Grid item spacing={1} xs={12}>
            <FormControl sx={{width: 500}} variant="standard">
              <InputLabel htmlFor="standard-adornment-password">Фамилия или номер паспорта</InputLabel>
              <Input
                id="standard-adornment-password"
                type='text'
                onChange={waitChangeForm}
              />
            </FormControl>
          </Grid>
          <Grid item spacing={1} xs={12}>
            {
              state?.length === 0 ?
                <Grid container sx={{cursor: 'pointer'}}>
                  <Grid item xs={12} sx={{height: 20}}></Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" sx={{color: 'text.secondary', ml: 1.5}}>Найдено 0</Typography>
                  </Grid>
                </Grid> : void 0
            }
            {
              state?.map((item) => {
                return (
                    <Grid container sx={[{cursor: 'pointer'},{
                      '&:hover': { backgroundColor: '#f0f0f0' },
                    }]} onClick={() => {onClick(item)}}>
                      <Grid item xs={12} sx={{height: 15}}></Grid>
                      <Grid item xs={12}>
                        <Grid container spacing={1} xs={12} sx={{pl: '5px'}}>
                          <Grid item sx={{pr: 1}}><Typography variant="body2" component="div" display="inline">{item?.lastName} {item?.firstName} {item?.middleName} {item?.name}</Typography></Grid>
                          <Grid item sx={{pr: 1}}><Typography variant="body2" component="div" display="inline">{item?.series} {item?.number}</Typography></Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}></Grid>
                      <Grid item xs={12} sx={{height: 15, borderBottom: 1, borderColor: '#dadada'}}></Grid>
                    </Grid>
                )
              })
            }
          </Grid>
        </Grid>
      </Container>
  )
}


/**
 * Поиск представителей организации
 * @constructor
 */
export const RepsSearch = ({handleAddExistRep}) => {
  const [data, setData] = useState([])

  return [(
      <FormSelectCtrl data={data} label="Представители" minWidth="400"
                      onChange={(e) => handleAddExistRep(e.target.value)}
                      disabled={!data?.length}
                      name="existingReps"/>
  ), setData];
}